<template>
  <v-card class="pa-1 rounded-lg">
    <v-card-text class="white">
      <v-card class="mb-7" color="comment" rounded="lg" outlined flat>
        <v-card-title>
          <v-spacer></v-spacer>

          <v-btn
            v-if="$store.getters['rolesUser/getCustomRole'](186)"
            @click="saveProvidersAllocation"
            class="btn-save"
            dark
            small
          >
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-card-title>
      </v-card>

      <AccountingAssign
        v-if="$store.getters['rolesUser/getCustomRole'](184)"
        v-model="form.id_account"
        :win="win"
        :assignAll="true"
        secondaryActionLabel="Limpiar"
        :secondaryActionDisabled="!providers.length"
        @accountChanged="accountChanged"
        @assignAllAccounts="assignAllAccounts"
        @secondaryAction="clearAllAccounts"
      >
      </AccountingAssign>
      <v-col
        v-if="$store.getters['rolesUser/getCustomRole'](184)"
        cols="12"
      >
        <v-radio-group v-model="changueAll" row>
          <v-radio
            label="Asignar Cuenta de Costos"
            value="CuentaCostos"
          ></v-radio>
          <v-radio
            label="Asignar Cuenta de Gastos"
            value="CuentaGastos"
          ></v-radio>
          <v-radio
            label="Asignar Cuenta de Cuentas por Pagar"
            value="CuentaCuentasPorPagar"
          ></v-radio>
          <v-radio
            label="Asignar Cuenta de Bancos"
            value="CuentaBanco"
          ></v-radio>
          <v-radio
            label="Asignar Gasto de Comisión (DCL)"
            value="GastoComision"
          ></v-radio>
          <v-radio
            label="Asignar Cuentas por Cobrar (DCL)"
            value="CuentasPorCobrar"
          ></v-radio>
        </v-radio-group>
      </v-col>

      
      <v-row class="ml-3 mr-3">
        <v-col cols="12" md="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click.prevent="accountingSpecificationsDialog = true" v-bind="attrs" v-on="on" >
                <v-icon class="mr-1">mdi-help-circle-outline</v-icon>
                Acerca de este formulario
              </v-btn>
            </template>
            <span>Especificaciones contables de las cuentas a asignar</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <VersatileFilter
        entity="lista"
        :filterEndpoint="$API.providers.getProvidersFilteredWithAccounts"
        :search="search"
        @emptyFilter="getAllProviders"
        @filtered="filterHandlerProviders"
        :columnfilterEndpoint="
          $API.providers.getProvidersFilteredColumnWithAccounts
        "
        :columnsSearch="columsConfig"
        :disableDates="true"
        v-if="$store.getters['rolesUser/getCustomRole'](178)"
      >
        <DxDataGrid
          ref="accountProviders"
          :data-source="providers"
          key-expr="ID_Provider"
          :show-row-lines="showRowLines"
          @exporting="onExporting"
          :show-borders="showBorders"
          :row-alternation-enabled="rowAlternationEnabled"
          @editing-start="onEditingStart"
          :scrolling="{ useNative: true }"
          :column-auto-width="true"
          @row-updating="validateData"
        >
          <DxExport :enabled="$store.getters['rolesUser/getCustomRole'](187)" />
          <DxEditing :allow-updating="true" mode="cell" />
          <DxPaging :page-size="10" />
          <DxColumn
            data-field="ID_Provider"
            caption="ID"
            :allow-updating="false"
          ></DxColumn>
          <DxColumn
            data-field="ProviderName"
            caption="Nombre del Proveedor"
            :allow-updating="false"
          ></DxColumn>
          <DxColumn
            data-field="ProviderContactName"
            caption="Contacto del Proveedor"
            :allow-updating="false"
          ></DxColumn>
          <DxColumn
            data-field="ProviderContactMobile"
            caption="Celular de Contacto del Proveedor"
            :allow-updating="false"
          ></DxColumn>
          <DxColumn :width="80" cell-template="show-template" caption=""></DxColumn>
          <DxColumn
            data-field="CuentaCostos"
            :allow-updating="true"
            caption="Cuenta de Costos"
          ></DxColumn>
          <DxColumn :width="80" cell-template="show-template_2" caption=""></DxColumn>
          <DxColumn
            data-field="CuentaGastos"
            :allow-updating="true"
            caption="Cuenta de Gastos"
          ></DxColumn>
          <DxColumn :width="80" cell-template="show-template_3" caption=""></DxColumn>
          <DxColumn
          data-field="CuentaCuentasPorPagar"
          :allow-updating="true"
          caption="Cuenta de Cuentas por Pagar"
          ></DxColumn>
          <DxColumn :width="80" cell-template="show-template_4" caption=""></DxColumn>
          <DxColumn
            data-field="CuentaBanco"
            :allow-updating="true"
            caption="Cuenta de Bancos"
          ></DxColumn>

          <DxColumn :width="80" cell-template="show-template_5" caption=""></DxColumn>
          <DxColumn
            data-field="GastoComision"
            :allow-updating="true"
            caption="Gasto de Comisión (DCL)"
          ></DxColumn>
          <DxColumn :width="80" cell-template="show-template_6" caption=""></DxColumn>
          <DxColumn
            data-field="CuentasPorCobrar"
            :allow-updating="true"
            caption="Cuentas por Cobrar (DCL)"
          ></DxColumn>
          <template #show-template="{ data }">
            <div>
              <a href="#" class="mx-1" @click="providersSelected = data; showModel =true; assignOne = 'CuentaCostos'">
                <v-icon>mdi-magnify

                </v-icon>
              </a>
            </div>
          </template>
          <template #show-template_2="{ data }">
            <div>
              <a href="#" class="mx-1" @click="providersSelected = data; showModel =true; assignOne = 'CuentaGastos'">
                <v-icon>mdi-magnify

                </v-icon>
              </a>
            </div>
          </template>
          <template #show-template_3="{data}">
            <div>
              <a href="#" class="mx-1" @click="providersSelected = data; showModel =true; assignOne = 'CuentaCuentasPorPagar'">
                <v-icon>mdi-magnify
  
                </v-icon>
              </a>
            </div>
          </template>
          <template #show-template_4="{data}">
            <div>
              <a href="#" class="mx-1" @click="providersSelected = data; showModel =true; assignOne = 'CuentaBanco'">
                <v-icon>mdi-magnify
  
                </v-icon>
              </a>
            </div>
          </template>
          <template #show-template_5="{data}">
            <div>
              <a href="#" class="mx-1" @click="providersSelected = data; showModel =true; assignOne = 'GastoComision'">
                <v-icon>mdi-magnify

                </v-icon>
              </a>
            </div>
          </template>
          <template #show-template_6="{data}">
            <div>
              <a href="#" class="mx-1" @click="providersSelected = data; showModel =true; assignOne = 'CuentasPorCobrar'">
                <v-icon>mdi-magnify

                </v-icon>
              </a>
            </div>
          </template>
        </DxDataGrid>
      </VersatileFilter>

      <v-dialog v-model="showModel" width="60%">
        <v-card>
          <AccountingItemForm
            :win="win"
            v-on:sendSelection="reactiveSelection"
          />
        </v-card>
      </v-dialog>

      <alert
        v-model="alert.show"
        :type="alert.type"
        :title="alert.header"
        :message="alert.body"
      ></alert>
    </v-card-text>

    <v-dialog v-model="accountingSpecificationsDialog" max-width="600" scrollable>
      <v-card>
        <v-card-title
          style="padding-left: 25px; padding-bottom: 25px;" class="text-h6"
        >
          <v-icon class="mr-1">mdi-information-slab-circle-outline</v-icon>
          Cuentas a Asignar a Proveedores
        </v-card-title>

        <v-card-text>
          <div class="pa-2">
            <p class="mb-6">
              En este formulario se pueden asignar cuentas contables a los proveedores registrados en el sistema. Estas cuentas se utilizan para la contabilización de movimientos en la sección de <strong>Partidas Automáticas</strong> o parametrizar contablemente dentro de la sección de <strong>Ingreso Masivo de Gastos Avanzado</strong>.
            </p>

            <p class="mb-2">
              Para <strong>Partidas Automáticas:</strong>
            </p>
            <p class="mb-2">
              <strong>Cuenta de Costos:</strong>
              Esta cuenta contempla el <strong>monto del egreso provocado por operaciones al contado.</strong> Representa los valores directamente relacionados con la producción o adquisición de bienes y servicios que generan ingresos.
            </p>

            <p class="mb-2">
              <strong>Cuenta de Gastos:</strong>
              Esta cuenta contempla el <strong>monto del egreso provocado por operaciones al contado.</strong> Valores de operaciones del negocio que no forman parte del costo directo del bien o servicio vendido.
            </p>

            <p class="mb-6">
              <strong>Cuenta de Cuentas por Pagar:</strong>
              Representa las obligaciones pendientes de pago a proveedores por bienes o servicios recibidos. Esta cuenta contempla operaciones a crédito.
            </p>

            <p class="mb-2">
              Para <strong>Ingreso Masivo Avanzado de Gastos:</strong>
            </p>
            <p class="mb-2">
              <strong>Cuenta de Costos:</strong>
              Esta cuenta contempla el monto relacionado al <strong>movimiento contable que provoca el ingreso del producto o servicio en los libros del negocio receptor (su negocio).</strong> Representa los valores directamente relacionados con la producción o adquisición de bienes y servicios que generan ingresos.
            </p>

            <p class="mb-2">
              <strong>Cuenta de Gastos:</strong>
              Esta cuenta contempla el monto operacional <strong>no relacionado al costo directo</strong> concerniente al <strong>movimiento contable que provoca la adquisición de servicios o bienes en los libros del negocio receptor (su negocio).</strong> Valores de operaciones del negocio que no forman parte del costo directo del bien o servicio vendido.
            </p>

            <p class="mb-2">
              <strong>Cuenta de Bancos:</strong>
              Esta cuenta contempla el monto relacionado al <strong>movimiento contable que provoca el pago a contado por la adquisición de productos, servicios o bienes en los libros del negocio receptor (su negocio).</strong> Representa el movimiento del pago al contado al proveedor.
            </p>

            <p class="mb-6">
              <strong>Cuenta de Cuentas por Pagar:</strong>
              Representa las obligaciones pendientes de pago a proveedores por bienes o servicios recibidos. Esta cuenta contempla operaciones a crédito.
            </p>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text="Cerrar"
            @click="accountingSpecificationsDialog = false"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import VersatileFilter from "@/components/VersatileFilter";
import AccountingItemForm from "./AccountingItemForm";
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxExport,
  DxEditing,
} from "devextreme-vue/data-grid";
import AccountingAssign from "./AccountingAssign.vue";
import { mapMutations, mapState } from "vuex";
import { printToExcel } from "@/helpers/printToexcel";
export default {
  name: "AllocationServices",
  props: ["win", "datafilter"],
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    AccountingItemForm,
    DxExport,
    VersatileFilter,
    AccountingAssign,
  },

  data() {
    return {
      changueAll: "CuentaCostos",
      accountingSpecificationsDialog: false,
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      assignOne: '',
      tab: null,
      panel: 0,
      form: {
        id_account: null
      },
      providersSelected: false,
      providers: [],

      search: {
        filter: null,
      },
      valid: null,
      editService: null,
      showModel: false,
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      typebusiness: null,
      columsConfig: [
        {
          name: "ip.ID_Provider",
          title: "ID",
          value: "",
          type: "text",
        },
        {
          name: "ip.ProviderName",
          title: "Nombre del proveedor",
          value: "",
          type: "text",
        },
        {
          name: "ip.ProviderContactName",
          title: "Contacto del proveedor",
          value: "",
          type: "text",
        },
        {
          name: "ip.ProviderContactMobile",
          title: "Celular de Contacto del Proveedor",
          value: "",
          type: "text",
        },
      ],

      filterServices: {},
      showOrderVacMed: false,
      optFilterOrder: 1,
      families: [],
      categories: [],
      subcategories: [],
      accountList: [],
      editableFieldsList: [
        "CuentaCostos",
        "CuentaGastos",
        "CuentaCuentasPorPagar",
        "CuentaBanco",
        "GastoComision",
        "CuentasPorCobrar"
      ],
      columnLabels: {
        CuentaCostos: "Cuenta de Costos",
        CuentaGastos: "Cuenta de Gastos",
        CuentaCuentasPorPagar: "Cuenta de Cuentas por Pagar",
        CuentaBanco: "Cuenta de Bancos",
        GastoComision: "Gasto de Comisión",
        CuentasPorCobrar: "Cuentas por Cobrar"
      },
    };
  },

  computed: {
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
    loading: {
      ...mapState({ get: "loading" }),
      ...mapMutations({ set: "loading" }),
    },
  },
  mounted() {
    this.$store.dispatch("rolesUser/getAllRoles");
    this.typebusiness =
      JSON.parse(localStorage.getItem("user")).businesstype || "";
    this.filterServices.business = JSON.parse(
      localStorage.getItem("user")
    ).businessid;
    this.filterServices.branch = JSON.parse(
      localStorage.getItem("user")
    ).branch;
    this.search.branch = this.filterServices.branch;
    this.search.business = this.filterServices.business;
    this.getAllProviders();
    this.getFamilies();
    this.getCategories();
    this.getSubs();
  },
  methods: {
    accountChanged( e ) {
      this.form.id_account = e
    },
    reactiveSelection(data) {
      this.showModel = false;
      this.providersSelected.data[ `new${ this.assignOne }` ] = data.id_account;
      this.providersSelected.data[ this.assignOne ] = data.account_code;
      this.providersSelected.data[ `new${ this.assignOne }Account_Code` ] = data.account_code;

      this.$refs.accountProviders.instance.saveEditData();
    },
    getFamilies() {
      if (!this.columsConfig[4] || !this.columsConfig[4].options) {
        return;
      }
      this.$API.itemtypes.getFamilies().then((response) => {
        this.families = response;
        this.families.forEach((family) => {
          this.columsConfig[4].options.push({
            name: family.name,
            value: family.id,
          });
        });
      });
    },
    getCategories() {
      if (!this.columsConfig[5] || !this.columsConfig[5].options) {
        return;
      }
      this.$API.itemtypes.getCategories().then((response) => {
        this.categories = response;
        this.categories.forEach((category) => {
          this.columsConfig[5].options.push({
            name: category.name,
            value: category.id,
          });
        });
      });
    },
    validateData(e) {
      for (const field of this.editableFieldsList) {
        if (!(field in e.newData)) {
          continue;
        }

        const newValue = e.newData[field];

        if (!newValue) {
          e.newData[`new${field}`] = null;
          e.newData[field] = "";
        } else {
          const found = this.accountList.find(
            (current) => current.account_code === newValue
          );

          if (found) {
            e.newData[`new${field}`] = found.id_account;
            e.newData[field] = found.account_code;
          } else {
            e.cancel = true;
            e.newData[field] = "";
            this.showAlert(
              "warning",
              "Error",
              "La cuenta ingresada no existe o no es candidata para la asignacion"
            );
          }
        }

        break;
      }
    },
    getSubs() {
      if (!this.columsConfig[6] || !this.columsConfig[6].options) {
        return;
      }
      this.$API.itemtypes.getSubs().then((response) => {
        this.subcategories = response;
        this.subcategories.forEach((subcategory) => {
          this.columsConfig[6].options.push({
            name: subcategory.name,
            value: subcategory.id,
          });
        });
      });
    },
    assignAllAccounts() {
      const found = this.accountList.find(
        (current) => current.id_account === this.form.id_account
      );

      if (!found) {
        this.showAlert("warning", "Error", "Debe seleccionar una cuenta valida");
        return;
      }

      for (const index in this.providers) {
        this.providers[index][`new${this.changueAll}`] = found.id_account;
        this.providers[index][this.changueAll] = found.account_code;
      }

      this.$refs.accountProviders.instance.refresh();
      this.showAlert(
        "success",
        "Exito",
        `Se ha actualizado la tabla asignando la cuenta seleccionada a la columna "${this.getColumnLabel()}". Revise los cambios y haga click en el boton verde para guardar.`
      );
    },
    clearAllAccounts() {
      for (const index in this.providers) {
        this.providers[index][`new${this.changueAll}`] = null;
        this.providers[index][this.changueAll] = "";
        this.providers[index][`new${this.changueAll}Account_Code`] = "";
      }

      this.$refs.accountProviders.instance.refresh();
      this.showAlert(
        "success",
        "Exito",
        `Se ha limpiado la columna "${this.getColumnLabel()}" para todos los proveedores del grid. Haga click en el boton verde para guardar.`
      );
    },
    getAllAccounts(dataToFormat) {
      this.$API.branchaccountcatalog
        .getAssignableAccounts()
        .then((response) => {
          this.accountList = response.data;
          this.matchAccounts(dataToFormat);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    matchAccounts(dataToFormat) {
      for (const index in dataToFormat) {
        const {
          CuentaCostos,
          CuentaGastos,
          CuentaCuentasPorPagar,
          CuentaBanco,
          GastoComision,
          CuentasPorCobrar,
        } = dataToFormat[index];

        const accountsObjThrough = {
          CuentaCostos,
          CuentaGastos,
          CuentaCuentasPorPagar,
          CuentaBanco,
          GastoComision,
          CuentasPorCobrar
        }

        for( const account in accountsObjThrough ) {
          const found = this.accountList.find(
            (current) => current.id_account === parseInt( accountsObjThrough[ account ] )
          );
          
          if (found) {
            dataToFormat[ index ][ account ] = found.account_code;
          }
        }

      }

      this.$refs.accountProviders.instance.saveEditData();
    },
    getColumnLabel() {
      return this.columnLabels[this.changueAll] || this.changueAll;
    },
    saveProvidersAllocation() {
      try {
        this.loading = true;
        this.$refs.accountProviders.instance.refresh();
        this.$API.branchaccountcatalog
          .assignAccountsProviders([...this.providers])
          .then((response) => {
            this.showAlert("success", "Exito", response.msg);
            this.loading = false;
            this.getAllProviders();
          })
          .catch((error) => {
            this.showAlert("error", "Error", error.message);
            this.loading = false;
          });
      } catch (error) {
        console.log(error);
      }
    },
    onExporting(e) {
      printToExcel(e, "Proveedores");
    },
    reload() {
      this.getAllProviders();
      setTimeout(() => {
        window.scrollTo(0, this.$store.getters.getScrollTop);
      }, 300);
    },
    showAlert(type, header, body) {
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
    },
    getAllProviders() {
      this.filterServices.withInnerjoins = true;
      this.$API.providers
        .getProvidersAllWithAccounts(this.filterServices)
        .then(async (response) => {
          await this.getAllAccounts(response);
          this.providers = response;
        });
    },
    onEditingStart(e) {
      if (!this.editableFieldsList.includes(e.column.dataField)) {
        e.cancel = true;
      }
    },

    async filterHandlerProviders(response) {
      this.providers = response;
      await this.getAllAccounts(response);
    },
  },
};
</script>
